import { Locale, LocalizeDataFormatRepositoryType, TemperatureUnit } from '51trips-frontend-core'

import i18n from '../i18n'

export class LocalizeDataFormatRepository implements LocalizeDataFormatRepositoryType {
  getLocales(): Locale[] {
    // The browser locale keeps driving number/date formatting (languageTag) and the country
    const languageTag = navigator.language
    const countryCode = languageTag.split('-')[1] || ''
    // Localized content (legal links, store URLs...) follows the language active in the app
    const appLanguage = i18n.resolvedLanguage || i18n.language || languageTag
    const languageCode = appLanguage.split('-')[0]

    return [new Locale(countryCode, languageTag, languageCode, false)]
  }

  getTemperatureUnit(): TemperatureUnit {
    return TemperatureUnit.celsius
  }

  usesMetricSystem(): boolean {
    return true
  }
}
